"use strict";

module.exports = {
  D_12: 12,
  D_18: 18,
  D_24: 24,
  D_30: 30,
  D_36: 36,
  D_42: 42,
  D_48: 48,
  D_60: 60,
  D_66: 66,
  D_78: 78,
  D_84: 84,
  D_90: 90,
  D_102: 102,
  D_108: 108,
  D_120: 120,
  D_138: 138,
  D_174: 174,
  D_198: 198
};